var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconEmail2 = function SvgIconEmail2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1666 15.166C12.8241 15.4005 12.4147 15.5175 12 15.4993C11.5852 15.5175 11.1758 15.4005 10.8333 15.166L2 10.416V18.8327C2 19.4957 2.26339 20.1316 2.73223 20.6004C3.20107 21.0693 3.83695 21.3327 4.49999 21.3327H19.5C20.163 21.3327 20.7989 21.0693 21.2677 20.6004C21.7366 20.1316 21.9999 19.4957 21.9999 18.8327V10.416L13.1666 15.166Z",
    fill: "#A9ADBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 4.66602H4.50001C3.83697 4.66602 3.20108 4.92941 2.73224 5.39825C2.2634 5.86709 2.00001 6.50297 2.00001 7.16601V7.99934C1.99922 8.14961 2.03713 8.29755 2.11011 8.42891C2.18309 8.56027 2.28867 8.67063 2.41668 8.74934L11.5833 13.7493C11.7113 13.8167 11.856 13.8456 12 13.8327C12.144 13.8456 12.2887 13.8167 12.4167 13.7493L21.5833 8.74934C21.7113 8.67063 21.8169 8.56027 21.8899 8.42891C21.9628 8.29755 22.0008 8.14961 22 7.99934V7.16601C22 6.50297 21.7366 5.86709 21.2677 5.39825C20.7989 4.92941 20.163 4.66602 19.5 4.66602Z",
    fill: "#A9ADBB"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEmail2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/IconEmail2.7b551e7c.svg";
export { ForwardRef as ReactComponent };